import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { AppViewModel } from 'app/viewModels';
import { NavigatorProvider } from 'app/helpers/RouterNavigation';
import { RouterModes } from 'app/viewModels/components/RouterViewModel';
import { AdminRouter } from './admin';
import { AnonymousRouter } from './anonymous';
import { DefaultRouter } from './default';
import { LoaderLayout } from 'app/layouts/LoaderLayout';
import { Spinner } from 'app/components/common/Spinner';

const getRouterByMode = (mode: RouterModes) => {
    switch (mode) {
        case RouterModes.Loading: {
            return <LoaderLayout>
                <Spinner />
            </LoaderLayout>;
        }

        case RouterModes.Anonymous: {
            return <AnonymousRouter />;
        }

        case RouterModes.Admin: {
            return <AdminRouter />;
        }

        default: {
            return <DefaultRouter />;
        }
    }
};

export const AppRouter = observer(() => {
    const { mode } = AppViewModel.Instance.router;

    return (
        <BrowserRouter>
            <NavigatorProvider />
            {getRouterByMode(mode)}
        </BrowserRouter>
    );
});

